import * as React from 'react';
import qs from 'query-string';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { company } from 'kts-platform-frame/api';
import history from 'kts-platform-frame/routes/history';
import { message } from 'antd';

export default class extends React.PureComponent {

    componentDidMount() {
        try {
            const search = qs.parse(window.location.search);
            const token = search.token as string;
            const redirectURL = search.redirectURL as string;
            const loginType = search.loginType as string;
            const loginURL = search.loginURL as string;

            if (loginURL) {
                window['$$_thirdLogin'] = loginURL; 
                window.localStorage.setItem('$$/system/loginURL', loginURL);
            } else {
                window.localStorage.removeItem('$$/system/loginURL');
            }

            if (token) {
                const { user } = MyStore.instance.getState();
                user.cToken = token;

                MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, user).then(() => {
                    // 获取用户数据
                    company.userInfo(this).then(userInfoData => {
                        if (!userInfoData.er) {
                            MyStore.instance.dispatch(reducers.system.ActionTypes.setLoginType, loginType || 'silent').then(() => {
                                if (redirectURL && redirectURL.indexOf('/silent') < 0) {
                                    history.replace(redirectURL);
                                } else {
                                    history.replace('/workbench/m/kingxunlian.workbench');
                                }
                                this.setGuideTipState();
                            });
                        } else {
                            message.error('登录失败！');
                            setTimeout(() => {
                                this.goLoginPage(loginURL);
                            }, 2000);
                        }
                    });
                });
            } else {
                this.goLoginPage(loginURL);
            }
        } catch (error) {
            const search = qs.parse(window.location.search);
            const loginURL = search.loginURL as string;
            this.goLoginPage(loginURL);
        }
    }

    render() {
        return null;
    }

    goLoginPage = (loginURL?: string) => {
        if (loginURL) {
            window.location.href = loginURL;
        } else {
            history.replace('/login');
        }
    }

    /** 去除当前登录用户新手引导查看状态 */
    private setGuideTipState = () => {
        const guideVersionUser = JSON.parse(sessionStorage.getItem("guideVersionUser"));
        const { user } = MyStore.instance.getState();
        if (guideVersionUser && guideVersionUser[user.userInfo.gUserId]) {
            delete guideVersionUser[user.userInfo.gUserId];
        }
        sessionStorage.setItem("guideVersionUser", JSON.stringify(guideVersionUser));
    }
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/LoginSilent/index.tsx